import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import LightMarketingHeader from '../../components/marketing/LightMarketingHeader';
import MarketingFooter from '../../components/marketing/MarketingFooter';
import LightMarketingPageContainer from '../../components/marketing/LightMarketingPageContainer';
import { lightStyles } from '../../styles/lightStyles';
import ReactMarkdown from 'react-markdown';
import termsMarkdown from '../../content/t_and_c_beta_2025_07_01.md?raw';

const TermsAndConditions: React.FC = () => {
  return (
    <LightMarketingPageContainer>
      <LightMarketingHeader selectedPage="terms-and-conditions" />
      <Container maxWidth="md" sx={{ pt: { xs: 6, md: 10 }, pb: { xs: 4, md: 8 }, minHeight: '80vh' }}>
        <Box sx={lightStyles.loginContainer}>
          <Typography variant="h3" sx={{ ...lightStyles.welcomeTitle, mb: 4 }}>
            Terms and Conditions
          </Typography>
          <Box sx={{
            textAlign: 'left',
            color: '#4B5563',
            maxWidth: '100%',
            '& h1, & h2, & h3': {
              fontFamily: '"Inter", "Assistant", sans-serif',
              color: '#1A1A1A',
              fontWeight: 700,
            },
            '& p': {
              lineHeight: 1.7,
              mb: 2,
            },
            '& a': {
              color: '#4F6BF6',
            },
          }}>
            <ReactMarkdown>{termsMarkdown}</ReactMarkdown>
          </Box>
        </Box>
      </Container>
      <MarketingFooter />
    </LightMarketingPageContainer>
  );
};

export default TermsAndConditions;
